import { Component } from '@angular/core';

@Component({
    selector: 'ciphr-root',
    template: `<router-outlet /> <ciphr-cookies-banner />`,
    standalone: false
})
export class AppComponent {}
